import { Link } from '@mui/material';
import { styles } from '~/modules/identification/styles.ts';

export const informerUsEntityInfo = (
  <>
    Необхідно обов'язково заповнити форму{' '}
    <Link
      sx={styles.link}
      href="https://www.eximb.com/assets/files/download/fatca-app-w-9.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      W-9
    </Link>
    (натисність на посилання, щоб скачати шаблон) та завантажити у блок “Документи”
  </>
);

export const informerForeignFinancialInstitutionInfo = (
  <>
    Надайте обов'язково заповнену форму{' '}
    <Link
      sx={styles.link}
      href="https://www.eximb.com/assets/files/download/fatca-app-w-8-ben-e.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      W-8 BEN-E
    </Link>
    (натисність на посилання, щоб скачати шаблон) та завантажити у блок “Документи”
  </>
);

export const informerFatcaStatusNFFEOption1 = (
  <>
    Надайте обов'язково заповнену форму{' '}
    <Link
      sx={styles.link}
      href="https://www.eximb.com/assets/files/download/fatca-app-w-8-ben-e.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      W-8 BEN-E
    </Link>
    (натисність на посилання, щоб скачати шаблон) та завантажити у блок “Документи”.
  </>
);

export const informerFatcaStatusNFFEOption2 = (
  <>
    Надайте обов'язково заповнену форму{' '}
    <Link
      sx={styles.link}
      href="https://www.eximb.com/assets/files/download/fatca-app-w-8-ben-e.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      W-8 BEN-E
    </Link>
    (натисність на посилання, щоб скачати шаблон) та завантажити у блок “Документи”. Та в разі, якщо
    Ваша установа є Пасивним нефінансовим іноземним суб'єктом господарювання з контролюючими
    особами/ власниками істотної участі США (Passive NFFE with substantial U.S. Owner(s)),
    заповніть, будь ласка, інформацію щодо кожної такої контролюючої особи/ власника істотної участі
    Вашої установи, яка є громадянином США або податковим резидентом США відповідно до законодавства
    США, за формою нижче, та надайте заповнену форму W-9 щодо кожної контролюючої особи/ власника
    істотної участі Вашої установи.
  </>
);

export const informerW8BEN = (
  <>
    Надайте обов'язково заповнену форму{' '}
    <Link
      sx={styles.link}
      href="https://www.eximb.com/assets/files/download/fatca-app-w-8-ben.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      W-8 BEN
    </Link>
    (натисність на посилання, щоб скачати шаблон) та завантажити у блок “Документи”.
  </>
);

export const informerCountryEng =
  'Вкажіть країну та населений пункт фактичного місця проживання або реєстрації англійською мовою, якщо особа зареєстрована та/чи проживає в США. Якщо особа зареєстрована та проживає у іншій країні (не в США) необхідно вказати іншу країну також англійською мовою.';
